import type { FC, CSSProperties } from 'react';
import { useState } from 'react';
import { Box, Link } from '@mui/material';
import { useTranslations } from 'next-intl';
// import Link from 'next/link';

interface IProps {
  containerSx?: CSSProperties;
  buttonStyle?: CSSProperties;
  inputStyle?: CSSProperties;
}

const SailEmail: FC<IProps> = ({ containerSx, buttonStyle, inputStyle }) => {
  const t = useTranslations('Home');
  const [email, setEmail] = useState<string>('');

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <Box
      sx={{ textAlign: 'center' }}
      mt={{
        xs: 2,
        md: 3,
      }}
    >
      <Box>
        <div
          style={{
            display: 'flex',
            border: '1px solid #000',
            borderRadius: '64px',
            padding: '6px',
            backgroundColor: '#fff',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: '0 auto',
            ...containerSx,
          }}
        >
          <div>
            <input
              type="text"
              placeholder={t('emailPlaceholder')}
              style={{
                border: 'none',
                padding: '8px 0px',
                marginLeft: '12px',
                outline: 'none',
                backgroundColor: 'transparent',
                fontSize: '18px',
                ...inputStyle,
              }}
              onChange={handleEmailChange}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Link
              href={`/book-demo?email=${email}`}
              sx={{
                color: '#fff',
                backgroundColor: '#0644F4',
                borderRadius: '700px',
                whiteSpace: 'nowrap',
                padding: '12px 24px',
                textAlign: 'center',
                textDecoration: 'none',
                ...buttonStyle,
              }}
              underline="none"
            >
              Sail to Success
            </Link>
          </div>
        </div>
      </Box>
    </Box>
  );
};

export default SailEmail;
